import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import { Roster } from "@/models";

const state = {
  rosterList: [],
  rosterListLoading: false,
  player: new Roster(),
  playerLoading: false,
  image: {},
  imageLoading: false,
  rosterListLimited: [],
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
